// eslint-disable-next-line no-shadow
export enum CandidateTest {
  PROFESSIONAL_PROFILE = 'PROFESSIONAL_PROFILE',
  LOGICAL_REASONING = 'LOGICAL_REASONING',
  PORTUGUESE = 'PORTUGUESE',
}
